import * as helper from '@/modules/helper/index'
import api from '@/modules/api'

export default {
  state: {
    notificationNodes: sessionStorage.notificationNodes ? JSON.parse(sessionStorage.notificationNodes) : []
  },
  getters: {
    notificationNodes (state) {
      return state.notificationNodes
    }
  },
  mutations: {
    setNotificationNodes (state, nodes) {
      state.notificationNodes = nodes
    }
  },
  actions: {
    populateNavigationNodes: async ({ rootGetters, commit }) => {
      let response = await api.Notification.getnodificationNodes(rootGetters.activeSubscriptionId)
      if (helper.IsValid(response, true)) {
        // let array = []
        // array.push(response)
        sessionStorage.notificationNodes = JSON.stringify(response)
        commit('setNotificationNodes', response)
      }
    },
    sendNotification: async ({ rootGetters, commit }, payload) => {
      payload.Subscription_Id = rootGetters.activeSubscriptionId
      let response = await api.Notification.sendNoification(payload)
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationStore.js